function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-210.93 -169.08)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.37008 0 0 .37008 210.71 166.03)"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1 0 0 1.5301 .125 -19.991)",
  d: "m41.25 33.938a18.25 5.1875 0 1 1-36.5 0 18.25 5.1875 0 1 1 36.5 0z",
  fill: "url(#i)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.374 12.468s2.8745 5.9276 9.5992 5.7604c14.093-0.35355 16.564-7.705 16.917-8.7656 0.35355-1.0607 0.89453-0.9 1.0196 0.080267 4.5962 41.719-31.897 23.819-33.193 16.714 7.2478-2.1213 5.4801-6.1872 5.4801-6.1872z",
  fill: "#fff",
  stroke: "#2e3436",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.738 30.066c6.7389 1.3478 10.171 0.09809 12.179-1.4528-0.53033-0.68501-1.4363-1.4363-1.4363-1.4363s2.3533 0.65394 3.182 1.7236c0.82629 1.0666 0.30681 1.7237 0.09056 3.0884-0.48141-1.1986-1.38-1.6481-1.5016-2.1243-1.8063 2.4969-6.3064 2.3932-12.514 0.20148z",
  fill: "url(#m)"
})), /*#__PURE__*/React.createElement("path", {
  d: "m36.969 11.844c-0.56198 0.9269-1.4065 2.0332-2.6875 3.0938-2.6319 2.179-7.0506 4.1623-14.281 4.3438-4.2244 0.10505-6.9527-1.9341-8.625-3.75l-0.125 4.4688c0.13611 0.4188 0.41546 1.3905-0.0625 2.7188-0.51431 1.4293-2.1545 2.8914-4.9688 4 0.25033 0.52203 0.49548 1.0436 1.25 1.7812 1.028 1.0049 2.457 2.088 4.1562 3.0625 3.3984 1.9489 7.8016 3.4932 11.906 3.5625 4.1047 0.06929 7.8571-1.2346 10.438-5 2.3787-3.4712 3.6825-9.3479 3-18.281z",
  fill: "none",
  opacity: 0.18539,
  stroke: "url(#j)",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.2778 0 0 1.2778 -75.127 -6.5078)",
  d: "m72.655 21.837a3.182 3.182 0 1 1-6.364 0 3.182 3.182 0 1 1 6.364 0z",
  fill: "url(#h)",
  stroke: "#888a85",
  strokeWidth: 0.78261
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-35.808 3.3629 26.345)",
  d: "m10.43 27.229a4.331 6.0988 0 1 1-8.6621 0 4.331 6.0988 0 1 1 8.6621 0z",
  fill: "url(#k)",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.85185 0 0 .85185 -3.9268 3.3955)",
  d: "m24.042 21.837a2.2981 2.2981 0 1 1-4.5962 0 2.2981 2.2981 0 1 1 4.5962 0z",
  fill: "#2e3436",
  stroke: "#000",
  strokeWidth: 1.1739
})), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-36.833 3.3665 26.6)",
  d: "m6.0938 22.156c-0.79825 0-1.5531 0.44617-2.1875 1.3438s-1.0938 2.2342-1.0938 3.7188 0.45938 2.8212 1.0938 3.7188 1.3893 1.3438 2.1875 1.3438c0.79825 0 1.5773-0.47639 2.2188-1.375s1.0938-2.2062 1.0938-3.6875-0.45228-2.7889-1.0938-3.6875-1.4205-1.375-2.2188-1.375z",
  fill: "none",
  opacity: 0.2809,
  stroke: "url(#g)",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m5.8336 23.251a1.7678 2.1213 0 1 1-3.5355 0 1.7678 2.1213 0 1 1 3.5355 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.76667 0 0 .76667 -2.5564 5.0298)",
  d: "m23.158 20.953a1.7678 1.7678 0 1 1-3.5355 0 1.7678 1.7678 0 1 1 3.5355 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.5 0 0 1.5 -82.168 -10.919)",
  d: "m72.655 21.837a3.182 3.182 0 1 1-6.364 0 3.182 3.182 0 1 1 6.364 0z",
  fill: "url(#h)",
  stroke: "#888a85",
  strokeMiterlimit: 10,
  strokeWidth: 0.66667
}), /*#__PURE__*/React.createElement("path", {
  transform: "translate(1.4142 .70711)",
  d: "m24.042 21.837a2.2981 2.2981 0 1 1-4.5962 0 2.2981 2.2981 0 1 1 4.5962 0z",
  fill: "#2e3436",
  stroke: "#000",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.9 0 0 .9 3.0229 2.6256)",
  d: "m23.158 20.953a1.7678 1.7678 0 1 1-3.5355 0 1.7678 1.7678 0 1 1 3.5355 0z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-.11485 -.38986 .38986 -.11485 24.715 29.689)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeWidth: 2.4604
}, /*#__PURE__*/React.createElement("path", {
  d: "m-23.364 23.568 3.7101 3.4692c8.347-6.3808 17.094-20.099 17.094-20.099 1.9763-2.2424-0.11692-3.7505-2.1649-2.3979 0 0-12.97 10.115-18.639 19.028z",
  fill: "url(#f)",
  stroke: "#673907"
}), /*#__PURE__*/React.createElement("path", {
  d: "m-30.45 32.814 2.2463 1.9338 8.4928-7.367 0.27506-0.70583 1.0944-0.01782c-0.4375-1.5625-2.9415-4.3835-4.8165-4.3835l0.08202 1.0901-0.66999 0.38003-6.7041 9.0702z",
  fill: "url(#e)",
  stroke: "#888a85"
}), /*#__PURE__*/React.createElement("path", {
  d: "m-23.801 28.377-4.3649 5.2665",
  fill: "none",
  stroke: "#fff",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  d: "m-45.341 42.77c10.444 0 18.37 1.2437 19.871-6.3547 1.2092-6.1233-7.2105-9.0574-11.383-3.5909-4.0193 5.266-8.4877 9.9456-8.4877 9.9456z",
  fill: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(2.0699 0 0 2.0699 -44.75 -41.51)",
  d: "m8.875 37.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 1 1 2.5 0z",
  fill: "#fff",
  opacity: 0.52778
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.3967 0 0 1.3967 -32.055 -25.877)",
  d: "m8.875 37.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 1 1 2.5 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m-38.544 40.909s3.7215 0.0943 6.1165-1.412c0.84735-0.53292 1.5158 0.64998 0.49382 1.0874-2.2074 0.94473-6.6104 0.32463-6.6104 0.32463z",
  fill: "url(#c)",
  opacity: 0.42778
})), /*#__PURE__*/React.createElement("path", {
  d: "m23.003 31.737c1.4974 0.14309 2.8496-0.27221 3.4119-0.47405 0.09822-0.55539 0.53655-1.6213 2.0461-1.6915l-0.53033-0.92808s-1.9666 1.3479-4.0659 1.7457z",
  fill: "url(#l)",
  fillRule: "evenodd"
})));

function SvgGimp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17.026mm",
    height: "12.664mm",
    viewBox: "0 0 17.026 12.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGimp);
export default __webpack_public_path__ + "static/media/gimp.96f2b4f6.svg";
export { ForwardRef as ReactComponent };